export const supportedLocales = process.env.REACT_APP_LOCALISATION_LIST ? process.env.REACT_APP_LOCALISATION_LIST.split(',') : [];
export const defaultLocale = process.env.REACT_APP_DEFAULT_LOCALE || 'en';
